import { Link } from "react-router-dom";
import { InstagramLogo, EnvelopeSimple } from "@phosphor-icons/react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/accmjott_vandy%27s%20logo.PNG";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E01A23]/10 bg-[#F5E6A0]"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-12 py-8 md:py-10">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="Vandy's" className="h-12 md:h-16 w-auto mb-3 object-contain" style={{ mixBlendMode: "multiply" }} />
            <p
              className="text-sm text-[#3a3a3a] leading-relaxed max-w-xs"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              Illustrated art prints and handmade goods, made with love and a whole lot of color.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4
              className="text-sm text-[#1A1A1A] tracking-wider mb-4"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              quick links
            </h4>
            <nav className="flex flex-col gap-2">
              {[
                { to: "/", label: "home" },
                { to: "/shop", label: "shop" },
                { to: "/about", label: "about" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-[#3a3a3a] hover:text-[#E01A23] transition-colors"
                  style={{ fontFamily: "'Courier New', Courier, monospace" }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-sm text-[#1A1A1A] tracking-wider mb-4"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              get in touch
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:hello@vandys.art"
                className="flex items-center gap-2 text-sm text-[#3a3a3a] hover:text-[#E01A23] transition-colors"
                style={{ fontFamily: "'Courier New', Courier, monospace" }}
              >
                <EnvelopeSimple size={16} />
                hello@vandys.art
              </a>
              <a
                href="https://www.instagram.com/vandys_studio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-[#3a3a3a] hover:text-[#E01A23] transition-colors"
                style={{ fontFamily: "'Courier New', Courier, monospace" }}
                data-testid="footer-instagram-link"
              >
                <InstagramLogo size={16} />
                @vandys_studio
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[#E01A23]/5 flex items-center justify-between">
          <p className="text-xs text-[#bbb]" style={{ fontFamily: "'Courier New', Courier, monospace" }}>
            &copy; {new Date().getFullYear()} Vandy's. All rights reserved.
          </p>
          <Link
            to="/admin"
            className="text-xs text-[#bbb] hover:text-[#E01A23] transition-colors"
            style={{ fontFamily: "'Courier New', Courier, monospace" }}
          >
            admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
